(function() {
  // Lazy-load product card images below the fold; keep the first viewport row eager.
  function applyLazy() {
    var cards = document.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      var img = cards[i].querySelector('img');
      if (!img || img.getAttribute('data-strata-lazy')) continue;
      img.setAttribute('data-strata-lazy', '1');
      var rect = img.getBoundingClientRect();
      if (rect.top > window.innerHeight) {
        img.setAttribute('loading', 'lazy');
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLazy);
  } else {
    applyLazy();
  }
  window.addEventListener('scroll', applyLazy, {passive: true});
  new MutationObserver(applyLazy).observe(document.body, {childList: true, subtree: true});
})();
